import Cookies from 'js-cookie'

const TokenKey = 'token'
const applyToken = 'applyToken'
const adminToken='Admin-Token'
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function removeAdminToken() {
    return Cookies.remove(adminToken)
  }

export function getApplyToken() {
  return Cookies.get(applyToken)
}

export function setApplyToken(token) {
  return Cookies.set(applyToken, token)
}

export function removeApplyToken() {
  return Cookies.remove(applyToken)
}


export function throttle(fn, delay, atleast) {
  let timer = null;
  let previous = null;
  return function() {
    const now = new Date();
    if (!previous) {
      previous = now;
    }
    if (atleast && now - previous > atleast) {
      fn();
      previous = now;
      clearTimeout(timer);
    } else {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn();
        previous = null;
      }, delay);
    }
  }
}
